import React from "react";
import { IconButton, Typography, Box, Stack, Switch } from "@mui/joy";
import { Info, ArrowBack, Groups } from "@mui/icons-material";
import { WhiteContainer } from "UI";
import { Builder } from "Common";
import useUsefullInfosContainer from "../../../../UsefullInfosStore";
import { useTranslation } from "react-i18next";

const Team = ({ id }) => {
	const { t } = useTranslation();

	const { setEditor, setUsefullInfosState, usefullInfosState } =
		useUsefullInfosContainer.useContainer();

	return (
		<WhiteContainer>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				sx={{ mb: 3 }}
				spacing={2}
			>
				<Stack direction="row" alignItems="center" spacing={1}>
					<IconButton onClick={() => setEditor(null)}>
						<ArrowBack />
					</IconButton>
					<Typography>{t("back_usefull_infos")}</Typography>
				</Stack>

				<Stack direction="row" spacing={1} alignItems="center">
					<Switch
						checked={usefullInfosState?.team?.active}
						onChange={(e) => {
							const v = e.target.checked;
							setUsefullInfosState({
								...usefullInfosState,
								team: {
									...usefullInfosState?.team,
									active: v,
								},
							});
						}}
					/>

					<Typography
						startDecorator={<Groups />}
						level="h5"
						sx={(theme) => ({
							textTransform: "uppercase",
							background: usefullInfosState?.team?.active
								? theme.vars.palette.primary[400]
								: "#EEE",
							color: usefullInfosState?.team?.active
								? "white"
								: "initial",
							borderRadius: "200px",

							pl: 2,
							pr: 2,
						})}
					>
						{t("team")}
					</Typography>
				</Stack>
			</Stack>

			<Box>
				<Builder
					content={usefullInfosState?.team?.content || []}
					action={(d) =>
						setUsefullInfosState({
							...usefullInfosState,
							team: {
								...usefullInfosState?.team,
								content: d,
							},
						})
					}
					editorConfig={{
						modalSize: 700,
						limitDepth: 1,
						itemsConfig: {
							default: {
								cardFields: ["title"],
								terms: {
									type: "usefull_info",
									type_plural: "usefull_infos",
									create_new_item: "add_usefull_infos",
									create_new_children:
										"create_new_usefull_infos",
									detail_tab: "item",
									children_type: "item",
									content_tab: "usefull_infos_content",
								},
								editor: {
									hasChildren: false,
									fields: [
										{
											label: "image",
											type: "simple-image",
										},
										{
											label: "title",
											type: "text",
											rules: {
												required: true,
											},
										},
										{
											label: "email",
											type: "text",
											rules: {
												required: false,
											},
										},
										{
											label: "phone",
											type: "text",
											rules: {
												required: false,
											},
										},
									],
								},
							},
						},
					}}
				/>
			</Box>
		</WhiteContainer>
	);
};

export default Team;
